import styled from "styled-components";

const OverflowSpan = styled.span`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font-weight: bold;
`;

export const StyledSpan = styled.span`
    color: var(--purple-lighter);
    font-weight: bold;
    font-size: 0.82rem;
`;

export const DivProgressList = styled.div`
    display: flex;
    width: calc(100% - 72px);
`;

export default OverflowSpan;
